import FamilyMember, { FamilyMemberData } from './FamilyMember'

export interface CustomerData extends FamilyMemberData {
  customer_id: string
  email: string
  phone_number: string
  gender: string
}

class Customer extends FamilyMember {
  customerId: string

  email: string

  phoneNumber: string

  gender: string

  constructor({
    customer_id,
    email,
    gender,
    phone_number,
    ...familyMemberData
  }: CustomerData) {
    super(familyMemberData)

    this.customerId = customer_id
    this.email = email
    this.phoneNumber = phone_number
    this.gender = gender
  }
}

export default Customer
